import React from 'react'

import Layout from '../components/layout'
import EthicOne from '../components/strategy/EthicOne'


const Work = props => (
  <Layout lang="en" title="Code of Ethics and Conduct" meta={{description: ''}} rootProps={{ className: 'page strategy' }}>
    <EthicOne lang="en" />
  </Layout>
)

export default Work
